import { useMutation } from '@tanstack/react-query';
import { postUserFlags } from './api';

import type { UserFlags } from './api';

type setUserFlagsProps = {
  accountId: number | undefined;
  userId: number | undefined;
  flags: Partial<UserFlags>;
};

export const useSetUserFlags = () => {
  return useMutation({
    mutationFn: async (props: setUserFlagsProps) => postUserFlags(props.accountId, props.userId, props.flags),
  });
};
